import { useEffect, useMemo } from 'react';
import cn from 'bem-cn';

import { getActiveCategories } from '../../../data/categories';

import { useUserContext } from '../../../contexts';

import { InfoBlock } from '../../../components/UI/InfoBlock/InfoBlock';
import { HighlightedText, Stack } from '../../../components/UI';
import { PromptInfoHeader } from '../../../components/PromptInfo/PromptInfoHeader';
import { PromptInfoAuthor } from '../../../components/PromptInfo/PromptInfoAuthor';
import { PromptInfoEditButton } from '../../../components/PromptInfo/PromptInfoEditButton';
import { ScreenSize, useGetScreenSize } from '../../../hooks';
// import { useAiGenerate } from '../PromptDetailsStep/useAiGenerate';

import { PromptPreviewStepProps } from './PromptPreviewStep.types';

import './PromptPreviewStep.scss';

const b = cn('prompt-preview-step');

export const PromptPreviewStep = ({
    promptText,
    promptTitle,
    promptProblem,
    selectedCategories,
    handlePrevStep,
}: PromptPreviewStepProps) => {
    const { user } = useUserContext();
    const screenSize = useGetScreenSize();
    // const { generatePromptResult } = useAiGenerate();
    // const [promptPreviewData, setPromptPreviewData] = useState<PromptPreviewData>({
    //     promptText: promptText,
    // });
    const categories = useMemo(() => getActiveCategories(), []);

    const getSelectedCategories = () => {
        return categories.filter(category => selectedCategories.includes(category.id)).map(category => category.name);
    };

    // const generateResult = async () => {
    //     try {
    //         // const generatedPromptResult = await generatePromptResult(promptText);
    //         // setPromptPreviewData((prevData: PromptPreviewData) => ({
    //         //     ...prevData,
    //         //     promptResult: generatedPromptResult.text,
    //         //     isEthicsBan: generatedPromptResult.isEthicsBan,
    //         // }));
    //     } catch (error) {
    //         console.error('Ошибка генерации заголовка:', error);
    //     }
    // };

    useEffect(() => {
        // generateResult();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <InfoBlock text="Ваш промпт будет выглядеть так" icon="eye" />
            <Stack spacing={8} className={b()}>
                <PromptInfoHeader
                    title={promptTitle}
                    description={promptProblem}
                    categories={getSelectedCategories()}
                    clickableCategories={false}
                />
                <div className={b('prompt-text')}>
                    <HighlightedText useMarkdown>{promptText}</HighlightedText>
                </div>
                {/* Отрываю результат */}
                {/* <PromptInfoBody
                    data={{
                        promptForExample: promptText,
                        example: 'В данный момент результат недоступен, но мы уже работаем над этим',
                        isMediaPrompt: false,
                    }}
                    isLoading={isLoading}
                    result={promptPreviewData}
                /> */}
                <PromptInfoAuthor
                    author={{
                        login: user?.login || '',
                        name:
                            user?.firstName && user?.lastName
                                ? `${user?.firstName} ${user?.lastName?.charAt(0)}.`
                                : user?.firstName || user?.login || '',
                        image: user?.avatarSrc || '',
                    }}
                    subtitle="Автор"
                />
                {screenSize !== ScreenSize.Mobile && <PromptInfoEditButton onClick={handlePrevStep} />}
            </Stack>
        </>
    );
};
